import React, { createContext, useContext, useState } from 'react';
import { trackProductEvent } from '../services/analyticsService';

const ErrorContext = createContext();

const normalizeErrorMessage = (message) => {
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  const apiMessage = message?.response?.data?.error;
  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    return apiMessage;
  }

  if (typeof message?.message === 'string' && message.message.trim()) {
    return message.message;
  }

  return 'An unexpected error occurred';
};

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const showError = (message) => {
    const normalizedMessage = normalizeErrorMessage(message);
    setError(normalizedMessage);
    trackProductEvent('error_occurred', {
      errorType: 'ui_error',
      message: normalizedMessage,
      surface: 'web_error_context'
    }).catch(() => {});
    console.error(normalizedMessage);
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    console.log(message);
  };

  const clearError = () => {
    setError(null);
    setSuccessMessage(null);
  };

  return (
    <ErrorContext.Provider value={{ error, successMessage, showError, showSuccess, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};
